import { ITagResponse } from './ITagResponse';
import { UUID } from '../shared/UUID';

export interface ITagData {
  id: UUID;
  label: string;
  type: string;
  isActive: boolean;
  isInAutomations: boolean;
}

export const convertITagResponseToITagData = ({ id, label, type, isActive, isInAutomations }: ITagResponse): ITagData => ({
  id,
  label,
  type,
  isActive,
  isInAutomations: isInAutomations ?? false,
});
